"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteListItem = void 0;
exports.insertSBeforeAvatar = insertSBeforeAvatar;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon"));
var color_convert_1 = __importDefault(require("color-convert"));
var react_jss_1 = __importDefault(require("react-jss"));
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var HiddenText_1 = require("./HiddenText");
var HighlightText_1 = require("./HighlightText");
var Wrapper = (0, react_jss_1.default)(function (theme) { return ({
    wrapper: function (_a) {
        var isSelected = _a.isSelected, hue = _a.hue, listItemHeight = _a.listItemHeight, opacity = _a.opacity;
        return (__assign(__assign({}, (isSelected && { background: "hsl(".concat(hue, ", 100%, 90%)") })), { borderColor: isSelected ? theme.colors.primary : "transparent", padding: "10px", paddingTop: "0px", paddingBottom: "0px", boxSizing: "border-box", height: listItemHeight, fontSize: "14px", display: "flex", width: "100%", color: "#000", transitionProperty: "opacity, transform, webkit-transform", transitionDuration: "350ms", opacity: opacity }));
    },
}); })(function (_a) {
    var classes = _a.classes, isSelected = _a.isSelected, hue = _a.hue, listItemHeight = _a.listItemHeight, opacity = _a.opacity, theme = _a.theme, props = __rest(_a, ["classes", "isSelected", "hue", "listItemHeight", "opacity", "theme"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.wrapper }, props)));
});
var ImageWrapper = (0, react_jss_1.default)({
    imageWrapper: function (_a) {
        var listItemHeight = _a.listItemHeight;
        return ({
            height: listItemHeight - 4,
            width: ((listItemHeight - 4) * 4) / 3,
            minWidth: ((listItemHeight - 4) * 4) / 3,
            display: "flex",
            justifyItems: "center",
            alignItems: "center",
        });
    },
})(function (_a) {
    var classes = _a.classes, listItemHeight = _a.listItemHeight, props = __rest(_a, ["classes", "listItemHeight"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.imageWrapper }, props));
});
var IconWrapper = (0, react_jss_1.default)({
    iconWrapper: {
        fontSize: "19px",
        fontFamily: "Roboto",
        color: "#9e9e9e",
        marginInlineEnd: "6px",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.iconWrapper }, props));
});
var Thumbnail = (0, react_jss_1.default)({
    thumbnail: function (_a) {
        var src = _a.src;
        return ({
            backgroundImage: "url(\"".concat(src, "\")"),
            backgroundSize: "cover",
            width: "100%",
            height: "100%",
        });
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.thumbnail }, props));
});
var StatusOverlay = (0, react_jss_1.default)(function (theme) { return ({
    statusOverlay: function (_a) {
        var status = _a.status;
        return (__assign(__assign(__assign({ borderRadius: "50%", marginInlineStart: "8px", marginInlineEnd: "6px", width: "8px", height: "8px", minWidth: "8px" }, (status === "live" && { backgroundColor: theme.colors.active })), (status === "offline" && {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: theme.colors.baseContrast050,
        })), (status !== "live" && status !== "offline" && { visibility: "hidden", display: "none" })));
    },
}); })(function (_a) {
    var classes = _a.classes, status = _a.status, theme = _a.theme, props = __rest(_a, ["classes", "status", "theme"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.statusOverlay }, props));
});
var Label = (0, react_jss_1.default)({
    label: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.label }, props));
});
var Hashtag = (0, react_jss_1.default)({
    hashtag: {
        fontSize: "19px",
        fontFamily: "Roboto",
        color: "#9e9e9e",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.hashtag }, props));
});
var HashtagContainer = (0, react_jss_1.default)({
    hashtagContainer: {
        margin: "0 10px",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.hashtagContainer }, props));
});
function insertSBeforeAvatar(url) {
    if (!url) {
        return "";
    }
    return url.replace(/\/avatar(\/|$)/, "/s/avatar$1");
}
var AutocompleteListItem = /** @class */ (function (_super) {
    __extends(AutocompleteListItem, _super);
    function AutocompleteListItem(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = { opacity: 0 };
        // New items should fade in.
        _this._timeout = setTimeout(function () {
            _this.setState({ opacity: 1 });
        }, 200);
        return _this;
    }
    AutocompleteListItem.prototype.componentWillUnmount = function () {
        // Cleanup if component has not faded in yet.
        // TODO: Add test on unmount while timeout is running.
        /* istanbul ignore next */
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = undefined;
        }
    };
    AutocompleteListItem.prototype.render = function () {
        var _a, _b;
        var _c = this.props, listItemHeight = _c.listItemHeight, keyword = _c.keyword, item = _c.item, index = _c.index, isSelected = _c.isSelected, linkTo = _c.linkTo, onClick = _c.onClick, label = _c.label, requiresAgeVerification = _c.requiresAgeVerification;
        var opacity = this.state.opacity;
        // transform is used to transition the list open/close.
        var transform = "translate3d(0px, ".concat(index * listItemHeight, "px, 0px)");
        var isTextBlurEnabled = (_b = (_a = this.props.user) === null || _a === void 0 ? void 0 : _a.ageVerificationRules) === null || _b === void 0 ? void 0 : _b.isTextBlurEnabled;
        var image = function (iconColor) {
            switch (item.type) {
                case "tag":
                    return ((0, jsx_runtime_1.jsx)(HashtagContainer, { children: (0, jsx_runtime_1.jsx)(Hashtag, { children: "#" }) }));
                case "performer": {
                    var thumbnailUrl = item.performer.thumbnail;
                    var src = requiresAgeVerification ? insertSBeforeAvatar(thumbnailUrl) : thumbnailUrl;
                    return (0, jsx_runtime_1.jsx)(Thumbnail, { src: src });
                }
                case "video":
                    return ((0, jsx_runtime_1.jsx)(IconWrapper, { children: (0, jsx_runtime_1.jsx)(SvgIcon_1.default, { name: "videoLibrary", fill: iconColor }) }));
            }
        };
        var onlineStatus = item.type === "performer" ? (item.performer.online ? "live" : "offline") : "none";
        // TODO: Investigate using a sytled(Link) instead of inline styles on the element.
        return ((0, jsx_runtime_1.jsx)(Ioc_1.ContextConsumer, { contexts: [Contexts_1.ILinkComponentContext, Contexts_1.IThemeContext], children: function (Link, theme) {
                var LinkComponent = ((0, jsx_runtime_1.jsxs)(Link, { "data-ta-locator": "AutocompleteListItem-link", style: { display: "flex", alignItems: "center", width: "100%" }, to: linkTo, children: [item.type === "performer" ? ((0, jsx_runtime_1.jsx)(ImageWrapper, { listItemHeight: listItemHeight, children: image(theme.colors.baseContrast040) })) : (image(theme.colors.baseContrast040)), (0, jsx_runtime_1.jsx)(StatusOverlay, { status: onlineStatus }), isTextBlurEnabled ? ((0, jsx_runtime_1.jsx)(HiddenText_1.HiddenText, { text: label, opacity: 0.6, dynamicUpperRangeThreshold: 15, dynamicWidthRange: { lowerRange: 20, upperRange: 50 } })) : ((0, jsx_runtime_1.jsx)(Label, { children: (0, jsx_runtime_1.jsx)(HighlightText_1.HighlightText, { baseColor: theme.colors.baseContrast040, highlightColor: theme.colors.baseShadow, label: label, keyword: keyword !== null && keyword !== void 0 ? keyword : "" }) }))] }));
                return ((0, jsx_runtime_1.jsx)(Wrapper, { theme: theme, tabIndex: -1, "data-ta-locator": "AutocompleteListItem", listItemHeight: listItemHeight, isSelected: isSelected !== null && isSelected !== void 0 ? isSelected : false, hue: color_convert_1.default.hex.hsl(theme.colors.primary)[0], onClick: onClick, opacity: opacity, transform: transform, children: LinkComponent }));
            } }));
    };
    AutocompleteListItem = __decorate([
        (0, Ioc_1.connectContextsToProps)({
            user: Contexts_1.IUserContext,
        })
    ], AutocompleteListItem);
    return AutocompleteListItem;
}(React.Component));
exports.AutocompleteListItem = AutocompleteListItem;
//# sourceMappingURL=AutocompleteListItem.js.map